
import { useState } from 'react';
import { useQueryClient } from "@tanstack/react-query";
import { transferWallet } from '../../API/ProtectedAuth';
import validateWalletTransferForm from '../../Utils/validateForm';
import { handleApiError } from '../../Utils/errorHandler';

const useWalletTransfer = () => {
  const queryClient = useQueryClient();

  const [values, setValues] = useState({
    phone_number: '',
    amount_sp: '',
    is_debt: false,
    amount_paid: '',
    note: ''
  });

  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const validationErrors = validateWalletTransferForm(values);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        phone_number: values.phone_number,
        amount_sp: parseFloat(values.amount_sp),
        is_debt: values.is_debt,
        note: values.note || ""
      };

      if (values.is_debt) {
        payload.amount_paid = parseFloat(values.amount_paid);
      }

      

      const response = await transferWallet(payload);
      setSuccess(response?.message || "تمت عملية التحويل بنجاح ");

      
      queryClient.invalidateQueries(["transactions"]);      
      queryClient.invalidateQueries(["dashboardReports"]);   
      queryClient.invalidateQueries(["financialReports"]);   
      queryClient.invalidateQueries(["walletBalance"]);   
      queryClient.invalidateQueries(["reportsQuickStats"]);   
      queryClient.invalidateQueries(["reportsTrending"]);   
      queryClient.invalidateQueries(["reportsPerformance"]);   

      
      setValues({
        phone_number: '',
        amount_sp: '',
        is_debt: false,
        amount_paid: '',
        note: ''
      });
    } catch (err) {
      const errorMessage = handleApiError(err);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    values,
    errors,
    error,
    success,
    isLoading,
    handleChange,
    handleSubmit
  };
};

export default useWalletTransfer;






























































































